
import React, { useEffect } from 'react';
import queryString from 'query-string';
import { Container, Row } from 'reactstrap';

import { WithLocalize } from '../../containers/I18nProvider';
import RequestLoginErrorMessage from '../../components/RequestLoginErrorMessage';
import ServiceApi from '../../services/ServiceApi';

import './style.scss';
import LoginForm from './LoginForm';

const Login = ({ location, translate }) => {
  useEffect(() => {
    document.title = 'NET TELECOM';
    document.body.style.backgroundColor = '#00b0f0';
  });

  const api = new ServiceApi(this);
  const parameters = queryString.parse(location.search);

  const _validateParams = () => {
    if (!parameters.client_id || !parameters.redirect_uri || !parameters.response_type)
      return false;
    return true;
  }

  return (
    <Container fluid={true} className="anet-body">
      <div className="row h-100">
        <div className="col-sm-12 my-auto">
          <Row>
              {
                _validateParams()
                  ? <LoginForm
                    api={api}
                    location={location}
                  />
                  : <RequestLoginErrorMessage
                    onlyMessage={true}
                    message={translate('RequestLoginErrorMessage')}
                  />
              }
          </Row>
        </div>
      </div>
    </Container>
  );
}

export default WithLocalize(Login);
